import {
	getProductStatus,
	getProductOverview,
	getChannelStockStatus,
	getFastMoveProduct,
} from '../../services/api/dashboard.api';
import {
	GET_DASHBOARD_PRODUCT_STATUS_REQUEST,
	GET_DASHBOARD_PRODUCT_STATUS_SUCCESS,
	GET_DASHBOARD_PRODUCT_STATUS_FAILURE,
	GET_DASHBOARD_PRODUCT_OVERVIEW_REQUEST,
	GET_DASHBOARD_PRODUCT_OVERVIEW_SUCCESS,
	GET_DASHBOARD_PRODUCT_OVERVIEW_FAILURE,
	GET_DASHBOARD_STOCK_STATUS_REQUEST,
	GET_DASHBOARD_STOCK_STATUS_SUCCESS,
	GET_DASHBOARD_STOCK_STATUS_FAILURE,
	GET_DASHBOARD_FAST_MOVE_REQUEST,
	GET_DASHBOARD_FAST_MOVE_SUCCESS,
	GET_DASHBOARD_FAST_MOVE_FAILURE,
} from '../types';
import {
	transformDashboardProductStatus,
	transformDashboardProductOverview,
	transformDashboardChannelStockStatus,
	transformDashboardFastMoveProduct,
} from '../../transforms/dashboard';
import { transformError } from '../../transforms/error';
import { filterCaseClub } from '../../helpers/filter';

export default {
	namespaced: true,

	state: {
		productStatus: {
			isLoading: false,
			error: null,
			data: transformDashboardProductStatus({}),
		},
		productOverview: {
			isLoading: false,
			error: null,
			data: transformDashboardProductOverview({}),
		},
		stockStatus: {
			isLoading: false,
			error: null,
			data: [],
		},
		fastMoveProduct: {
			isLoading: false,
			error: null,
			data: transformDashboardFastMoveProduct({}),
		},
	},

	mutations: {
		[GET_DASHBOARD_PRODUCT_STATUS_REQUEST](state) {
			state.productStatus.isLoading = true;
			state.productStatus.error = null;
			state.productStatus.data = [];
		},
		[GET_DASHBOARD_PRODUCT_STATUS_SUCCESS](state, data) {
			state.productStatus.isLoading = false;
			state.productStatus.data = transformDashboardProductStatus(data);
		},
		[GET_DASHBOARD_PRODUCT_STATUS_FAILURE](state, error) {
			state.productStatus.isLoading = false;
			state.productStatus.error = transformError(error);
		},
		[GET_DASHBOARD_PRODUCT_OVERVIEW_REQUEST](state) {
			state.productOverview.isLoading = true;
			state.productOverview.error = null;
			state.productOverview.data = [];
		},
		[GET_DASHBOARD_PRODUCT_OVERVIEW_SUCCESS](state, data) {
			state.productOverview.isLoading = false;
			state.productOverview.data = transformDashboardProductOverview(data);
		},
		[GET_DASHBOARD_PRODUCT_OVERVIEW_FAILURE](state, error) {
			state.productOverview.isLoading = false;
			state.productOverview.error = transformError(error);
		},
		[GET_DASHBOARD_STOCK_STATUS_REQUEST](state) {
			state.stockStatus.isLoading = true;
			state.stockStatus.error = null;
			state.stockStatus.data = [];
		},
		[GET_DASHBOARD_STOCK_STATUS_SUCCESS](state, { data }) {
			state.stockStatus.isLoading = false;
			const channelCaseClub = data.filter((item) => filterCaseClub(item.slug)); // filter only caseclub
			state.stockStatus.data = channelCaseClub.map(transformDashboardChannelStockStatus);
		},
		[GET_DASHBOARD_STOCK_STATUS_FAILURE](state, error) {
			state.stockStatus.isLoading = false;
			state.stockStatus.error = transformError(error);
		},
		[GET_DASHBOARD_FAST_MOVE_REQUEST](state) {
			state.fastMoveProduct.isLoading = true;
			state.fastMoveProduct.error = null;
			state.fastMoveProduct.data = [];
		},
		[GET_DASHBOARD_FAST_MOVE_SUCCESS](state, { data }) {
			state.fastMoveProduct.isLoading = false;
			state.fastMoveProduct.data = data.map(transformDashboardFastMoveProduct);
		},
		[GET_DASHBOARD_FAST_MOVE_FAILURE](state, error) {
			state.fastMoveProduct.isLoading = false;
			state.fastMoveProduct.error = transformError(error);
		},
	},

	actions: {
		async getDashboardProductStatus({ commit }) {
			try {
				commit(GET_DASHBOARD_PRODUCT_STATUS_REQUEST);
				const { data } = await getProductStatus();
				commit(GET_DASHBOARD_PRODUCT_STATUS_SUCCESS, data);
			} catch (error) {
				commit(GET_DASHBOARD_PRODUCT_STATUS_FAILURE, error);
			}
		},
		async getDashboardProductOverview({ commit }) {
			try {
				commit(GET_DASHBOARD_PRODUCT_OVERVIEW_REQUEST);
				const { data } = await getProductOverview();
				commit(GET_DASHBOARD_PRODUCT_OVERVIEW_SUCCESS, data);
			} catch (error) {
				commit(GET_DASHBOARD_PRODUCT_OVERVIEW_FAILURE, error);
			}
		},
		async getDashboardChannelStockStatus({ commit }) {
			try {
				commit(GET_DASHBOARD_STOCK_STATUS_REQUEST);
				const { data } = await getChannelStockStatus();
				commit(GET_DASHBOARD_STOCK_STATUS_SUCCESS, data);
			} catch (error) {
				commit(GET_DASHBOARD_STOCK_STATUS_FAILURE, error);
			}
		},
		async getDashboardFastMoveProduct({ commit }, params) {
			try {
				commit(GET_DASHBOARD_FAST_MOVE_REQUEST);
				const { data } = await getFastMoveProduct(params);
				commit(GET_DASHBOARD_FAST_MOVE_SUCCESS, data);
			} catch (error) {
				commit(GET_DASHBOARD_FAST_MOVE_FAILURE, error);
			}
		},
	},
};
